// اضافه کردن کتابخانه ها به صفحه
import * as React from 'react';
import {Add, AddOutlined, Delete, ExpandMore} from '@mui/icons-material';
import {Accordion, AccordionDetails, AccordionSummary, Autocomplete, Backdrop, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography} from '@mui/material';
import {useTranslation} from "react-i18next";

import SimpleMap from "../../components/SimpleMap";
import CancelIcon from "@mui/icons-material/Cancel";
import {setLoading} from "../../redux/loading/actions";
import {useDispatch, useSelector} from "react-redux";
import {setListBox, setSizeBox} from "../../redux/multiOrder/infoBox/actions";
import {setAddressReceiver, setPostalCodeReceiver} from "../../redux/multiOrder/receiver/actions";
import {useLocation, useNavigate, useSearchParams} from "react-router-dom";
import {useSnackbar} from "notistack";
import {ReactComponent as Plus} from "../../assets/img/icons/plus.svg";
import {addCommas, handleSetQuery, removeNonNumeric} from "../../assets/js/main";
import HandleFetchData from "../../plugin/HandleFetchData";
import {ThemeContext} from "../../App";


export default function InfoBox(props) {
  // استفاده از متود های i18n برای چند زبان کردن پروژه و تغییر زبان پروژه
  const {t} = useTranslation();
  const navigate = useNavigate();
  const {enqueueSnackbar} = useSnackbar();
  const {fetchData} = HandleFetchData()
  const location = useLocation();
  const theme = React.useContext(ThemeContext)

  const tokenStorage = localStorage.getItem('token')
  const dispatch = useDispatch();
  const selector = useSelector((st) => st)

  // متغیر و useState های لوکال صفحه
  const [listBoxSize, setListBoxSize] = React.useState([]);
  const [listAddress, setListAddress] = React.useState([])
  const [afterAddressDialog, setAfterAddressDialog] = React.useState(false);
  const [coordinateDialog, setCoordinateDialog] = React.useState(false);
  // const [insuranceList, setInsuranceList] = React.useState([]);
  const [textStateAndCity, setTextStateAndCity] = React.useState('')
  const [listStateAndCity, setListStateAndCity] = React.useState([])
  const [expanded, setExpanded] = React.useState(0);


  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  }

  React.useEffect(() => {
    getBoxSize()
    getStateAndCity()
  }, [])

  // متد دریافت لیست سایز جعبه ها
  const getBoxSize = async () => {
    dispatch(setLoading(true))
    let fetch = await fetchData('', 'GET', `/StandardBoxSize`, '', "application/json",'', '','')
    if (fetch?.message === "Network Error" && !tokenStorage) {
      enqueueSnackbar(t("error.t1"), {
        variant: 'error',
        TransitionProps: {
          direction: 'down',
        },
        anchorOrigin: {
          horizontal: 'center',
          vertical: 'top'
        }
      })
      navigate('/auth/login', {replace: true})
    } else if (!fetch?.IsSuccess) {
      enqueueSnackbar(fetch?.message, {
        variant: 'warning',
        TransitionProps: {
          direction: 'down',
        },
        anchorOrigin: {
          horizontal: 'center',
          vertical: 'top'
        }
      })
    } else if (fetch && fetch?.StatusCode == 500) {
      navigate({
        pathname: "/pageInternalServer",
        search: location?.search
      });
    } else {
      setListBoxSize(fetch?.Data)
    }
    dispatch(setLoading(false))
  }

  // متد دریافت لیست استان ها
  const getStateAndCity = async (e) => {
    dispatch(setLoading(true))
    let fetch = await fetchData('nbl', 'GET', `/v1/Address/getStateCity`, '', "application/json", {
      "term": e
    }, 'postex')
    setListStateAndCity(fetch?.data)
    dispatch(setLoading(false))
  }


  // متد دریافت لیست آدرس های قبلی
  const getPreviousAddress = async (e) => {
    dispatch(setLoading(true))
    let fetch = await fetchData('', 'GET', `/FetchAddresses?toSearch=${e}`, '', "application/json",'', '','')
    dispatch(setLoading(false))
    setListAddress(fetch?.Data || [])
  }


  const handlerRemoveForm = (i) => {
    let formValues = [...selector?.multi_info_box?.list];
    formValues.splice(i, 1);
    dispatch(setListBox(formValues))
  }

  const handlerChangeInput = (e, i) => {
    let formValues = [...selector?.multi_info_box?.list];
    formValues[i][e.target.name] = e.target.value;
    dispatch(setListBox(formValues))
  }

  const handlerSetValueToList = (e, i, key, type) => {
    let list = [...selector?.multi_info_box?.list]
    list[i][key] = type === 'string' ? String(e) : type === 'number' ? Number(e) : e
    dispatch(setListBox(list))
  }


  const setInfoStateAndCity = (value, index) => {
    handlerSetValueToList(value?.name?.split('-')[1] || '', index, 'Reciver_City')
    // handlerSetValueToList(value?.StateProvinceName || '', index, 'Reciver_City')
    handlerSetValueToList(value?.id?.split('-')[1] || '', index, 'Reciver_townId')
    // handlerSetValueToList(value?.StateProvinceId || '', index, 'Reciver_townId')
    handlerSetValueToList(value?.id?.split('-')[0] || '', index, 'Reciver_StateId')
    // handlerSetValueToList(value?.CountryId || '', index, 'Reciver_StateId')
    handlerSetValueToList(value?.lat || '', index, 'ReciverLat', 'string')
    handlerSetValueToList(value?.lon || '', index, 'ReciverLon', 'string')
  }

  const setInfoReceiver = (value, index) => {
    handlerSetValueToList(value?.FirstName || '', index, 'Reciver_FristName')
    handlerSetValueToList(value?.LastName || '', index, 'Reciver_LastName')
    // handlerSetValueToList(value?.national_code || ', index, 'national_code')
    handlerSetValueToList(value?.ZipPostalCode || '', index, 'postal_code')
    handlerSetValueToList(value?.email || '', index, 'Reciver_Email')
    // handlerSetValueToList(value?.company || ', index, 'Reciver_Company')
    handlerSetValueToList(value?.PhoneNumber || '', index, 'Reciver_mobile')
    // handlerSetValueToList(value?.phone_no || ', index, 'phone_no')
    handlerSetValueToList(value?.Address1 || '', index, 'Reciver_Address')
    handlerSetValueToList(value?.StateProvinceName || '', index, 'Reciver_City')
    handlerSetValueToList(value?.StateProvinceId || '', index, 'Reciver_townId')
    // handlerSetValueToList(value?.Country || ', index, 'Reciver_State')
    handlerSetValueToList(value?.CountryId || '', index, 'Reciver_StateId')
    handlerSetValueToList(value?.Lat || '', index, 'ReciverLat', 'string')
    handlerSetValueToList(value?.Lon || '', index, 'ReciverLon', 'string')

  }


  return (
     <>
       {selector?.loading?.isLoading &&
       <div className="backdrop-loading">
         <div className="backdrop-bg">
           <div className="loader" style={theme.darkMode ? {backgroundImage: "url('/splash2.gif')"} : {backgroundImage: "url('/splash1.gif')"}}/>
         </div>
       </div>
       }

       <div className="infoBoxMultiOrderPage">
         <div className="container">
           <section className="s1 titleSection">
             <h4 className="">{t("multiOrder.s2.t1")}</h4>
             <button type="button" onClick={() => {
               props.handlerAddForm()
               dispatch(setAddressReceiver(''))
             }} id="handlerAddForm">
               {t("multiOrder.s2.t2")}
               <AddOutlined/>
             </button>
           </section>
           <section className="s2">
             {
               selector?.multi_info_box?.list?.map((item, index) => {
                 return (
                    <Accordion key={index} expanded={expanded === index} onChange={handleChange(index)}>
                      <AccordionSummary
                         expandIcon={<ExpandMore/>}
                         aria-controls={'panel' + index + 'a-content'}
                         id={'panel' + index + 'a-header'}
                      >
                        <Typography>{t("multiOrder.s2.t3")}{index + 1}</Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <div className="row">
                          <div className="col-12 col-md-6">
                            <label className="required">{t("multiOrder.s2.t4")}</label>
                            <input type="text" name="content" value={item?.GoodsType || ""}
                                   onChange={(e) => handlerSetValueToList(e.target.value, index, 'GoodsType')} id="content"/>
                          </div>
                          <div className="col-12 col-md-6">
                            <label className="required">{t("multiOrder.s2.t5")}</label>
                            <select aria-label="Default select example"
                                    id="size"
                                    onChange={(event) => {

                                      if (event?.target?.value === 'max') {
                                        dispatch(setSizeBox(event?.target?.value))
                                      } else {
                                        dispatch(setSizeBox(''))
                                        handlerSetValueToList(
                                           listBoxSize?.find(x => x?.Id.toString() === event?.target?.value.toString())?.Name, index, 'CartonSizeName'
                                        )
                                        handlerSetValueToList(
                                           listBoxSize?.find(x => x?.Id.toString() === event?.target?.value.toString())?.Length, index, 'length'
                                        )
                                        handlerSetValueToList(
                                           listBoxSize?.find(x => x?.Id.toString() === event?.target?.value.toString())?.Width, index, 'width'
                                        )
                                        handlerSetValueToList(
                                           listBoxSize?.find(x => x?.Id.toString() === event?.target?.value.toString())?.Height, index, 'height'
                                        )
                                      }
                                    }}>
                              <option value="" selected disabled>{selector?.multi_info_box?.size || t("homeDesktop.s1.t4.tt10")}</option>
                              {
                                listBoxSize?.map((item, index) => <option key={item?.Id} value={item?.Id}>{item?.Name}</option>)
                              }

                              <option value="max">{t("homeDesktop.s1.t4.tt22")}</option>

                            </select>

                            {
                              selector?.multi_info_box?.size === 'max' &&
                              <div className="row">
                                <div className="col-4">
                                  <input type="number" min="1" name="length" id="length"
                                         onChange={(event) =>
                                            handlerSetValueToList(event?.target?.value, index, 'length')}
                                         placeholder={t("multiOrder.s2.t7")} value={item?.length || ""}/>
                                </div>
                                <div className="col-4">
                                  <input type="number" min="1" name="width" id="width"
                                         onChange={(event) => handlerSetValueToList(event?.target?.value, index, 'width')}
                                         placeholder={t("multiOrder.s2.t8")} value={item?.width || ""}/>
                                </div>
                                <div className="col-4">
                                  <input type="number" min="1" name="height" id="height"
                                         onChange={(event) => handlerSetValueToList(event?.target?.value, index, 'height')}
                                         placeholder={t("multiOrder.s2.t9")} value={item?.height || ""}/>
                                </div>
                              </div>
                            }

                          </div>
                          <div className="col-12 col-md-6">
                            <label className="required">{t("multiOrder.s2.t10")}</label>
                            <input type="text" name="rialValue" value={item?.ApproximateValue}
                                   inputMode='numeric' id="rialValue"
                                   onChange={(e) => handlerSetValueToList(
                                      addCommas(removeNonNumeric(e.target.value)), index, 'ApproximateValue', 'string'
                                   )}/>
                          </div>
                          <div className="col-12 col-md-6">
                            <label className="required">{t("multiOrder.s2.t11")}</label>
                            <input type="text" name="weight" value={item?.Weight}
                                   inputMode='numeric' id="weight"
                                   onChange={(e) => handlerSetValueToList(
                                      addCommas(removeNonNumeric(e.target.value)), index, 'Weight', 'string'
                                   )}/>
                          </div>

                          <div className="col-12 col-md-6">
                            <label className="required">{t("multiOrder.s1.t2")}</label>
                            <div className="d-flex align-items-start">
                              <Autocomplete
                                 className="w-100"
                                 inputValue={item?.Reciver_Address || selector?.multi_receiver?.address}
                                 noOptionsText={t("autoComplete.t1")}
                                 value={item?.Reciver_Address || selector?.multi_receiver?.address}
                                 id="previous-address-sender-1"
                                 disablePortal
                                 onChange={(e, value, reason) => {
                                   if (reason === 'clear') {
                                     setInfoReceiver('', index)
                                   } else {
                                     setInfoReceiver(value, index)
                                   }
                                 }}
                                 options={listAddress || []}
                                 getOptionLabel={(option) => option?.Address1 || ''}
                                 renderOption={(props, option) => <li {...props} key={option?.Id}>{option?.Address1}</li>}
                                 renderInput={(params) =>
                                    <TextField {...params}
                                               hiddenLabel
                                               size="small"
                                               placeholder={t("singleOrder.sender.t16")}
                                               onChange={event => {
                                                 dispatch(setAddressReceiver(event.target.value))
                                                 event.target.value?.length >= 3 && getPreviousAddress(event.target.value)
                                               }}
                                               InputProps={{
                                                 ...params.InputProps,
                                                 endAdornment: (
                                                    <React.Fragment>
                                                      {selector?.loading?.isLoading ? <CircularProgress style={{margin: '0 5px'}} size={20}/> : null}
                                                      {params.InputProps.endAdornment}
                                                    </React.Fragment>
                                                 ),
                                               }}
                                    />}
                              />
                              <div className="btnGroup_yellow m-0 btn-add-address w-auto ">
                                <button className="btnFill" onClick={() => {
                                  setAfterAddressDialog(true)
                                }} id="openAfterAddressDialog">
                                  <Add/>
                                </button>
                              </div>
                            </div>

                            {
                              props.validation?.address_validation_Receiver &&
                              <p className="error">{props.validation?.address_validation_Receiver}</p>
                            }


                            {
                              item?.Reciver_Address && (!item?.ReciverLat || !item?.ReciverLon) &&
                              <div className="btnGroup_yellow btn-add-coordinate">
                                <button className="btnFill" onClick={() => {
                                  setCoordinateDialog(true)
                                }} id="openCoordinateDialog">
                                  {t("singleOrder.receiver.t29")}
                                </button>
                              </div>
                            }
                          </div>

                          <div className="col-12 col-lg-6">
                            <label className="required">{t("singleOrder.sender.t6")}</label>
                            <input type="text" name="firstName" id="firstName"
                                   value={item?.Reciver_FristName}
                                   onChange={e => handlerSetValueToList(e.target.value, index, 'Reciver_FristName')}/>
                          </div>
                          <div className="col-12 col-lg-6">
                            <label className="required">{t("singleOrder.sender.t7")}</label>
                            <input type="text" name="lastName" id="lastName"
                                   value={item?.Reciver_LastName}
                                   onChange={e => handlerSetValueToList(e.target.value, index, 'Reciver_LastName')}/>

                          </div>
                          <div className="col-12 col-lg-6">
                            <label className="required">{t("singleOrder.sender.t8")}</label>
                            <input type="text" name="mobile" className="numeric" value={item?.Reciver_mobile}
                                   onChange={e => e.target.value.length <= 11 && handlerSetValueToList(removeNonNumeric(e.target.value), index, 'Reciver_mobile')}
                                   id="mobileNumber"
                            />
                          </div>

                          <div className="col-12 col-md-6">
                            <label className="required">{t("singleOrder.receiver.t27")}</label>
                            <input type="text" name="postalCode" className="numeric" value={item?.Reciver_PostCode}
                                   onChange={e => e.target.value.length <= 10 && handlerSetValueToList(removeNonNumeric(e.target.value), index, 'Reciver_PostCode')}
                                   id="postalCode"
                            />
                          </div>

                          <div className="col-12 col-lg-6">
                            <label>{t("singleOrder.sender.t9")}</label>
                            <input type="email" name="email" id="email"
                                   value={item?.Reciver_Email}
                                   onChange={e => handlerSetValueToList(e.target.value, index, 'Reciver_Email')}/>
                          </div>


                          <div className="col-12 d-flex justify-content-end mt-5">
                            <button type="button" onClick={() => handlerRemoveForm(index)} id="handlerRemoveForm">
                              <Delete/>
                            </button>
                          </div>
                        </div>
                      </AccordionDetails>

                      <Dialog
                         open={afterAddressDialog}
                         onClose={() => setAfterAddressDialog(false)}
                         aria-labelledby="alert-dialog-title"
                         aria-describedby="alert-dialog-description"
                         className="addressDialog"
                      >
                        <DialogTitle id="alert-dialog-title">
                          <div className="icon ">
                            <Plus/>
                          </div>
                        </DialogTitle>
                        <DialogContent>
                          <div className="closed">
                            <button type="button" onClick={() => setAfterAddressDialog(false)} id="closeAfterAddressDialog">
                              <CancelIcon/>
                            </button>
                          </div>
                          <h5>{t("multiOrder.s1.t3")}</h5>
                          <Autocomplete
                             inputValue={textStateAndCity}
                             noOptionsText={t("autoComplete.t1")}
                             id="previous-address-receiver-3"
                             disablePortal
                             autoHighlight
                             loading={selector?.loading?.isLoading}
                             onChange={(e, value, reason) => {
                               if (reason === 'clear') {
                                 setTextStateAndCity('')
                                 setInfoStateAndCity(null, index)
                               } else {
                                 setTextStateAndCity(value?.name)
                                 setInfoStateAndCity(value, index);
                               }
                             }}
                             options={listStateAndCity || []}
                             getOptionLabel={(option) => option?.name}
                             renderInput={(params) =>
                                <TextField {...params}
                                           hiddenLabel
                                           size="small"
                                           placeholder={t("singleOrder.receiver.t28")}
                                           onChange={(event) => {
                                             setTextStateAndCity(event?.target?.value)
                                             event?.target?.value?.length > 2 && getStateAndCity(event?.target?.value)
                                           }}
                                           InputProps={{
                                             ...params.InputProps,
                                             endAdornment: (
                                                <React.Fragment>
                                                  {selector?.loading?.isLoading ? <CircularProgress style={{margin: '0 5px'}} size={20}/> : null}
                                                  {params.InputProps.endAdornment}
                                                </React.Fragment>
                                             ),
                                           }}
                                />}
                          />

                          {
                            item?.Reciver_townId && <>
                             <textarea rows="2" value={item?.Reciver_Address || selector?.multi_receiver?.address}
                                       placeholder={t("multiOrder.s1.t20")} id="address"
                                       onChange={e => dispatch(setAddressReceiver(e?.target?.value))}/>

                              {
                                props.validation?.address_validation_Receiver &&
                                <p className="error">{props.validation?.address_validation_Receiver}</p>
                              }

                              <SimpleMap
                                 handlerLngFromMap={(event) => handlerSetValueToList(event || '', index, 'ReciverLon', 'string')}
                                 handlerLatFromMap={(event) => handlerSetValueToList(event || '', index, 'ReciverLat', 'string')}
                                 handlerAddressFromMap={(event) => {
                                   handlerSetValueToList((event?.subdivision_prefix + " " + event?.address) || '', index, 'Reciver_Address')
                                   dispatch(setAddressReceiver(event?.subdivision_prefix + " " + event?.address))
                                 }
                                 }
                                 coordinates={[
                                   {
                                     "pointX": selector?.multi_info_box?.list[index]?.ReciverLat,
                                     "pointY": selector?.multi_info_box?.list[index]?.ReciverLon
                                   }
                                 ]}
                                 searchInMap={textStateAndCity}
                                 showSearchInMap={false}
                                 address={selector?.multi_info_box?.list[index]?.Reciver_Address}
                              />
                            </>
                          }
                        </DialogContent>
                        <DialogActions>
                          <Button className="yellow" onClick={() => setAfterAddressDialog(false)} id="closeAfterAddressDialog">
                            {t("multiOrder.s1.t21")}
                          </Button>
                        </DialogActions>
                      </Dialog>

                      {/*set coordinate dialog*/}
                      <Dialog
                         open={coordinateDialog}
                         onClose={() => setCoordinateDialog(false)}
                         aria-labelledby="alert-dialog-title"
                         aria-describedby="alert-dialog-description"
                         className="addressDialog"
                      >
                        <DialogTitle id="alert-dialog-title">
                          <div className="icon ">
                            <Plus/>
                          </div>
                        </DialogTitle>
                        <DialogContent>
                          <div className="closed">
                            <button type="button" onClick={() => setCoordinateDialog(false)} id="closeCoordinateDialog">
                              <CancelIcon/>
                            </button>
                          </div>
                          <h5>{t("singleOrder.receiver.t29")}</h5>
                          <SimpleMap
                             handlerLngFromMap={(event) => handlerSetValueToList(event || '', index, 'ReciverLon', 'string')}
                             handlerLatFromMap={(event) => handlerSetValueToList(event || '', index, 'ReciverLat', 'string')}
                             coordinates={[
                               {
                                 "pointX": selector?.multi_info_box?.list[index]?.ReciverLat,
                                 "pointY": selector?.multi_info_box?.list[index]?.ReciverLon
                               }
                             ]}
                          />
                        </DialogContent>
                        <DialogActions>
                          <Button className="yellow" onClick={() => {
                            setCoordinateDialog(false)
                          }} id="closeCoordinateDialog">
                            {t("singleOrder.receiver.t22")}
                          </Button>
                        </DialogActions>
                      </Dialog>

                    </Accordion>
                 )
               })
             }
           </section>
         </div>
       </div>
     </>
  )
}
